export default "__VITE_ASSET__Cpo5a9d5__"